(function () {
 'use strict';
 const STORAGE = 'frostout-cart-preview-v55';
 const number = value => Math.max(0, Math.round(Number(value) || 0));
 const unitsText = n => n + (n === 1 ? ' sztuka' : (n % 10 >= 2 && n % 10 <= 4 && !(n % 100 >= 12 && n % 100 <= 14) ? ' sztuki' : ' sztuk'));
 function cartModel(cart, config) {
  const variants = new Map(config.variants.map(v => [String(v.id), v]));
  const lines = (cart.items || []).map(item => {
   const variant = variants.get(String(item.variant_id || item.id));
   const quantity = number(item.quantity), units = quantity * (variant ? variant.pack : 1);
   const price = number(item.final_line_price ?? item.line_price ?? number(item.price) * quantity);
   const original = number(item.original_line_price ?? number(item.original_price ?? item.price) * quantity);
   const regular = Math.max(original, price, variant ? number(variant.regular) * quantity : 0);
   return { key: item.key, variant, quantity, units, price, regular, saving: regular - price,
    title: variant ? variant.title : String(item.product_title || item.title || 'Produkt'),
    image: item.featured_image?.url || item.image || (variant ? config.image : '') };
  });
  const total = number(cart.total_price), regular = Math.max(total, lines.reduce((a,l) => a + l.regular, 0));
  return { lines, units: lines.reduce((a,l) => a + l.units, 0), total, regular, saving: regular - total,
   frostUnits: lines.filter(l => l.variant).reduce((a,l) => a + l.units, 0) };
 }
 function packUpdates(cart, config, pack) {
  const target = config.variants.find(v => v.pack === pack);
  if (pack !== 0 && (!target || !target.available)) throw new Error('Ten zestaw jest chwilowo niedostępny. Wybierz inną opcję.');
  const ids = new Set(config.variants.map(v => String(v.id))), updates = {};
  const lines = cart.items.filter(item => ids.has(String(item.variant_id || item.id)));
  lines.forEach(item => { updates[item.key] = 0; });
  if (target) {
   const existing = lines.find(item => String(item.variant_id || item.id) === String(target.id));
   updates[existing ? existing.key : String(target.id)] = 1;
  }
  return updates;
 }
 function previewCart(config, pack) {
  const v = config.variants.find(v => v.pack === pack && v.available);
  return {currency:config.currency, total_price:v ? v.price : 0, item_count:v ? 1 : 0, items:v ? [{key:'preview-' + v.id,variant_id:v.id,quantity:1,price:v.price,original_price:v.price,final_line_price:v.price,original_line_price:v.price,image:config.image}] : []};
 }
 function deadlineState(config, now) {
  if (!config.deadlineConfirmed || !/T.*(?:Z|[+-]\d{2}:\d{2})$/.test(config.deadline || '')) return null;
  const end = Date.parse(config.deadline);
  if (!Number.isFinite(end) || end <= now) return null;
  const s = Math.ceil((end - now) / 1000), days = Math.floor(s / 86400);
  return (days ? days + ' dni ' : '') + [Math.floor(s % 86400 / 3600),Math.floor(s % 3600 / 60),s % 60].map(n => String(n).padStart(2,'0')).join(':');
 }
 if (typeof module !== 'undefined' && module.exports) { module.exports = {cartModel,packUpdates,previewCart,deadlineState,unitsText}; return; }
 let activeCleanup;
 function init() {
  const dialog = document.querySelector('[data-fo-cart-drawer]');
  if (!dialog || dialog.dataset.ready) return;
  const configNode = document.querySelector('[data-fo-cart-config]');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch { return; }
  if (!Array.isArray(config.variants)) return;
  activeCleanup?.();
  const listeners = new AbortController();
  let disposed = false;
  dialog.dataset.ready = '1';
  const preview = document.documentElement.dataset.foPreview === 'true';
  const $ = selector => dialog.querySelector(selector), template = document.querySelector('[data-fo-cart-line-template]');
  const money = value => new Intl.NumberFormat('pl-PL',{style:'currency',currency:config.currency || 'PLN'}).format(value / 100);
  let cart = config.initialCart || {items:[],total_price:0}, busy = false, failed = false, previousFocus, previousOverflow = '', countdown;
  const assetUrl = value => {
   const name = String(value || '').split('/').pop().split('?')[0];
   if (preview && window.FrostOutAssets?.[name]) return window.FrostOutAssets[name];
   const url = String(value || '');
   return /^(https?:|data:image\/|\/)/.test(url) ? url : '';
  };
  if (preview) {
   let pack = 0;
   try { pack = Number(sessionStorage.getItem(STORAGE)) || 0; } catch {}
   cart = previewCart(config,pack);
  }
  function feedback(message, error = false) {
   $('[data-fo-cart-feedback]').textContent = error ? '' : message;
   $('[data-fo-cart-error]').textContent = error ? message : '';
   if (error && !cart.items.length) $('[data-fo-cart-feedback]').textContent = message;
  }
  function setBusy(value) {
   busy = value; dialog.setAttribute('aria-busy',String(value));
   dialog.querySelectorAll('[data-fo-line-remove],[data-fo-line-minus],[data-fo-line-plus],[data-fo-cart-upgrade-button]').forEach(button => {
    button.disabled = value || button.dataset.unavailable === 'true';
   });
   const link = $('[data-fo-cart-checkout]');
   link.setAttribute('aria-disabled',String(value || failed || !cart.items.length));
   link.textContent = value ? 'AKTUALIZUJEMY KOSZYK…' : 'PRZEJDŹ DO PŁATNOŚCI →';
  }
  function render() {
   if (disposed) return;
   const model = cartModel(cart,config), list = $('[data-fo-cart-lines]');
   list.replaceChildren();
   $('[data-fo-cart-count]').textContent = unitsText(model.units);
   document.querySelectorAll('[data-fo-cart-badge]').forEach(n => { n.textContent = model.units; n.hidden = !model.units; });
   $('[data-fo-cart-empty]').hidden = !!model.lines.length;
   $('[data-fo-cart-footer]').hidden = !model.lines.length;
   $('[data-fo-cart-assurance]').hidden = !model.lines.length;
   $('[data-fo-cart-preview]').hidden = !preview;
   model.lines.forEach(line => {
    const node = template.content.firstElementChild.cloneNode(true), q = s => node.querySelector(s);
    q('h3').textContent = line.title;
    q('img').alt = line.title; q('img').src = assetUrl(line.image); q('img').hidden = !line.image;
    q('[data-fo-line-description]').textContent = line.variant ? (line.units === 2 ? 'Duet · jedna dla Ciebie, druga dla bliskiej osoby' : 'Jedna dla Ciebie') : unitsText(line.units);
    q('[data-fo-line-regular]').textContent = money(line.regular); q('[data-fo-line-regular]').hidden = line.saving <= 0;
    q('[data-fo-line-price]').textContent = money(line.price);
    q('[data-fo-line-unit]').textContent = line.units > 1 ? money(line.price / line.units) + ' / szt.' : '';
    q('[data-fo-line-quantity]').textContent = line.units;
    q('[data-fo-line-saving]').textContent = line.saving > 0 ? 'Oszczędzasz ' + money(line.saving) : '';
    const available = pack => !!config.variants.find(v => v.pack === pack && v.available);
    const plus = q('[data-fo-line-plus]'), minus = q('[data-fo-line-minus]');
    plus.dataset.unavailable = String(!!line.variant && (model.frostUnits >= 2 || !available(2)));
    minus.dataset.unavailable = String(!!line.variant && model.frostUnits > 1 && !available(1));
    plus.addEventListener('click',() => line.variant ? choosePack(2) : changeOther(line.key,line.quantity + 1));
    minus.addEventListener('click',() => line.variant ? choosePack(model.frostUnits > 1 ? 1 : 0) : changeOther(line.key,Math.max(0,line.quantity - 1)));
    q('[data-fo-line-remove]').setAttribute('aria-label','Usuń ' + line.title + ' z koszyka');
    q('[data-fo-line-remove]').addEventListener('click',() => line.variant ? choosePack(0) : changeOther(line.key,0));
    list.append(node);
   });
   $('[data-fo-cart-regular]').textContent = money(model.regular);
   $('[data-fo-cart-savings]').textContent = money(model.saving);
   $('[data-fo-cart-total]').textContent = money(model.total);
   const single = config.variants.find(v => v.pack === 1), duo = config.variants.find(v => v.pack === 2);
   $('[data-fo-cart-upgrade]').hidden = !(model.frostUnits === 1 && single && duo?.available);
   if (single && duo) {
    $('[data-fo-cart-upgrade-copy]').textContent = 'Dodaj drugą za ' + money(duo.price - single.price) + '. W duecie ' + money(duo.price / 2) + ' za sztukę.';
    $('[data-fo-cart-upgrade-button]').textContent = 'WYBIERAM DUET — ' + money(duo.price);
   }
   setBusy(busy);
  }
  async function request(path, body) {
   const controller = new AbortController(), timeout = setTimeout(() => controller.abort(),15000);
   try {
    const root = (window.Shopify?.routes?.root || config.root || '/').replace(/\/?$/,'/');
    const response = await fetch(root + path,{method:body ? 'POST' : 'GET',credentials:'same-origin',cache:'no-store',signal:controller.signal,headers:{Accept:'application/json',...(body ? {'Content-Type':'application/json'} : {})},...(body ? {body:JSON.stringify(body)} : {})});
    if (!response.ok) throw new Error(response.status === 422 ? 'Wybrany zestaw jest chwilowo niedostępny. Wybierz inną opcję.' : 'Nie udało się zaktualizować koszyka. Spróbuj ponownie.');
    const result = await response.json();
    if (!Array.isArray(result.items) || !Number.isFinite(result.total_price)) throw new Error('Nie udało się odczytać koszyka. Spróbuj ponownie.');
    config.currency = result.currency || config.currency;
    return result;
   } catch (error) {
    if (error.name === 'AbortError') throw new Error('Połączenie trwa zbyt długo. Otwórz koszyk ponownie.');
    if (error instanceof TypeError) throw new Error('Brak połączenia. Sprawdź internet i spróbuj ponownie.');
    throw error;
   } finally { clearTimeout(timeout); }
  }
  async function refresh() {
   if (preview || busy) return;
   setBusy(true); feedback('Wczytujemy koszyk…');
   try { cart = await request('cart.js'); failed = false; feedback(''); }
   catch (error) { failed = true; feedback(error.message,true); }
   finally { setBusy(false); render(); }
  }
  function tick() {
   const text = deadlineState(config,Date.now());
   $('[data-fo-cart-countdown]').hidden = !text || !cart.items.length;
   $('[data-fo-cart-clock]').textContent = text || '';
   if (!text && countdown) { clearInterval(countdown); countdown = null; }
  }
  function open() {
   if (!dialog.open) { previousFocus = document.activeElement; previousOverflow = document.body.style.overflow; document.body.style.overflow = 'hidden'; dialog.showModal(); }
   render(); tick();
   if (deadlineState(config,Date.now()) && !countdown) countdown = setInterval(tick,1000);
   $('[data-fo-cart-close]').focus();
  }
  async function choosePack(pack) {
   if (busy) return;
   open(); setBusy(true); feedback('Aktualizujemy Twój zestaw…');
   try {
    if (preview) {
     packUpdates(cart,config,pack); cart = previewCart(config,pack);
     try { sessionStorage.setItem(STORAGE,String(pack)); } catch {}
    } else {
     const fresh = await request('cart.js'), updates = packUpdates(fresh,config,pack);
     cart = Object.keys(updates).length ? await request('cart/update.js',{updates}) : fresh;
    }
    failed = false;
    const physical = cartModel(cart,config).frostUnits;
    feedback(pack === 0 ? 'Produkt usunięty z koszyka.' : 'Gotowe — w koszyku ' + unitsText(physical) + ' FrostOut.');
   } catch (error) {
    failed = true; feedback(error.message,true);
    // A failed write can have an uncertain outcome; never retry a mutation automatically.
    if (!preview) { try { cart = await request('cart.js'); } catch {} }
   } finally { setBusy(false); render(); tick(); }
  }
  async function changeOther(key,quantity) {
   if (busy || preview) return;
   setBusy(true);
   try { cart = await request('cart/change.js',{id:key,quantity}); failed = false; feedback('Koszyk zaktualizowany.'); }
   catch (error) { failed = true; feedback(error.message,true); }
   finally { setBusy(false); render(); }
  }
  dialog.querySelectorAll('[data-fo-cart-close]').forEach(b => b.addEventListener('click',() => dialog.close()));
  dialog.addEventListener('click',event => { if (event.target === dialog) { const r = dialog.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
  dialog.addEventListener('close',() => { document.body.style.overflow = previousOverflow; if(countdown) clearInterval(countdown); countdown = null; previousFocus?.focus?.(); });
  $('[data-fo-cart-upgrade-button]').addEventListener('click',() => choosePack(2));
  $('[data-fo-cart-checkout]').addEventListener('click',event => {
   if (preview || busy || failed || !cart.items.length) { event.preventDefault(); if(preview) feedback('To lokalny podgląd. Płatność będzie dostępna w sklepie Shopify.'); }
  });
  document.addEventListener('click',event => {
   const trigger = event.target.closest('[data-fo-cart-open]');
   if (!trigger) return;
   event.preventDefault(); open(); refresh();
  },{signal:listeners.signal});
  document.addEventListener('submit',event => {
   const form = event.target;
   if (!form.matches('.fo-form')) return;
   event.preventDefault(); event.stopImmediatePropagation();
   const selected = form.querySelector('[data-fo-variant]:checked');
   if (!selected || selected.dataset.available !== 'true') return;
   choosePack(Number(selected.dataset.pack));
  },{capture:true,signal:listeners.signal});
  activeCleanup = () => {
   disposed = true; listeners.abort();
   if (dialog.open) dialog.close();
   if (countdown) clearInterval(countdown);
  };
  render();
 }
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init); else init();
 document.addEventListener('shopify:section:load',init);
})();
